import { BaseEntity } from '../../core/domain/base.entity';

export class Customizacao extends BaseEntity {
  usuario: string;
  preferenciaJson: string;
}
